import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["carrier", "category", "state"]

  filter() {
    const filters = {
      carrier: this.carrierTarget.value,
      category: this.categoryTarget.value,
      state: this.stateTarget.value
    }
    this.stimulate("CategoryFactorReflex#filter", filters);
  }
}
